<template>
  <div class="ticket-container">
    <div class="showcase-header">
        <h1 class="title">Ticket & Price</h1>
      </div>
    <div class="showcase-section">
      <div class="showcase-text">
        <div class="hours-content">
          <h2 class="subtitle">Opening Hours</h2>
          <div class="hours-details">
            <div class="hours-item">
              <i class="hours-icon">📅</i>
              <p class="time">Monday - Sunday</p>
            </div>
            <div class="hours-item">
              <i class="hours-icon">🕒</i>
              <p class="time">9:30 am to 5:00 pm</p>
            </div>
          </div>
          <p class="timechange">*Opening hours may vary depending on private functions, please check Google Maps for updates.</p>
          <button class="price-btn" @click="showPriceTable">View Price Details</button>
        </div>
      </div>
      
      <div class="showcase-images">
        <img src="@/assets/ticket1.jpg" alt="Play Area 1" class="showcase-img img1">
        <img src="@/assets/ticket2.png" alt="Play Area 2" class="showcase-img img2">
      </div>
    </div>

    <div class="ticket-grid">
      <!-- Kids Pass (6-12 months) -->
      <div class="ticket-card">
        <div class="card-header pink">
          <h2 class="card-title">Kids Pass</h2>
          <div class="age-range">0-12 months</div>
        </div>
        
        <div class="card-content">
          <div class="price-section">
            <h3>Weekdays</h3>
            <p>All Day Unlimited Pass $12</p>
          </div>

          <div class="divider"></div>

          <div class="price-section">
            <h3>Weekends</h3>
            <p>All Day Unlimited Pass $14</p>
            <p class="note">*Infants under 6 months get free entry with older siblings.</p>
          </div>
        </div>
      </div>

      <!-- Kids Pass (1 Year +) -->
      <div class="ticket-card">
        <div class="card-header yellow">
          <h2 class="card-title">Kids Pass</h2>
          <div class="age-range">1 Year +</div>
        </div>
        
        <div class="card-content">
          <div class="price-section">
            <h3>Weekdays</h3>
            <p>One-hour $15</p>
            <p>Two-hour $27</p>
            <p>All Day Unlimited Pass $36</p>
          </div>

          <div class="divider"></div>

          <div class="price-section">
            <h3>Weekends</h3>
            <p>One-hour $17</p>
            <p>Two-hour $31</p>
            <p>All Day Unlimited Pass $41</p>
          </div>
        </div>
      </div>

      <!-- Adult Pass -->
      <div class="ticket-card">
        <div class="card-header blue">
          <h2 class="card-title">Adult Pass</h2>
          <div class="age-range">Per person</div>
        </div>
        
        <div class="card-content">
          <div class="price-section">
            <h3>Weekdays</h3>
            <p>$5.5</p>
          </div>

          <div class="divider"></div>

          <div class="price-section">
            <h3>Weekends/PH</h3>
            <p>$5.5</p>
            <p class="note">*Adults must accompany kids.</p>
          </div>
        </div>
      </div>
    </div>
    <p class="notice">*Weekend prices applied on public holidays</p>
    <p class="notice">*Socks are compulsory in KiddozCafe. Age limited is 0-8 years old, children over 16 years old will charge as an adult fee.</p>
  </div>
</template>

<script>
export default {
  name: 'TicketView',
  methods: {
    showPriceTable() {
      this.$emit('show-price-table')
    }
  }
}
</script>

<style scoped>
.ticket-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
  padding-top: 120px;
}

.showcase-section {
  max-width: 1200px;
  margin: 0 auto 4rem;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.showcase-header {
  text-align: center;
  margin-bottom: 2rem;
}

.title {
  font-size: 3rem;
  color: #FF8B8B;
  font-weight: bold;
  font-family: 'Lobster';
  position: relative;
  display: inline-block;
}

.title::after {
  content: '';
  position: absolute;
  width: 50%;
  height: 4px;
  background: linear-gradient(to right, #FFD1D1, #FFE5A3);
  bottom: -10px;
  left: 25%;
  border-radius: 2px;
}

.showcase-text {
  text-align: left;
  padding-right: 2rem;
  background-color: white;
  border-radius: 15px;
  padding: 1.5rem;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-left: 6px solid #FFD1D1;
}

.hours-content {
  display: flex;
  flex-direction: column;
}

.subtitle {
  font-size: 1.8rem;
  color: #583525;
  font-family: 'Lobster';
  margin-bottom: 1.5rem;
  position: relative;
  display: inline-block;
}

.subtitle::after {
  content: '';
  position: absolute;
  width: 70%;
  height: 2px;
  background-color: #FFE5A3;
  bottom: -8px;
  left: 0;
}

.hours-details {
  margin-bottom: 1.5rem;
}

.hours-item {
  display: flex;
  align-items: center;
  margin-bottom: 0.8rem;
}

.hours-icon {
  font-size: 1.4rem;
  margin-right: 1rem;
  color: #FF8B8B;
  font-style: normal;
}

.time {
  font-size: 1.2rem;
  color: #583525;
  margin: 0;
}

.timechange {
  font-size: 1rem;
  color: #FF8B8B;
  margin-top: 1rem;
  font-style: italic;
}

.showcase-images {
  display: flex;
  gap: 2rem;
  justify-content: center;
  flex-wrap: wrap;
}

.showcase-img {
  width: 45%;
  max-width: 500px;
  height: auto;
  border-radius: 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}

.showcase-img:hover {
  transform: scale(1.03);
}

.img1 {
  border: 10px solid #FFD1D1;
}

.img2 {
  border: 10px solid #FFE5A3;
}

.price-btn {
  background-color: #FF8B8B;
  color: white;
  border: none;
  padding: 0.8rem 1.5rem;
  margin-top: 1.5rem;
  border-radius: 30px;
  font-size: 1.1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  align-self: flex-start;
}

.price-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 8px rgba(0, 0, 0, 0.15);
  background-color: #FF7777;
}

.ticket-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  margin: 3rem auto;
  max-width: 1200px;
  padding: 0 2rem;
}

.ticket-card {
  background: white;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}

.ticket-card:hover {
  transform: translateY(-5px);
}

.card-header {
  padding: 1.5rem;
  text-align: center;
}

.pink {
  background-color: #FFD1D1;
}

.yellow {
  background-color: #FFE5A3;
}

.blue {
  background-color: #D6E6F2;
}

.card-content {
  padding: 2rem;
  background: white;
}

.card-title {
  font-size: 2.5rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
  color: white; /* 恢复原设计的白色标题 */
}

.age-range {
  font-size: 1.5rem;
  color: white; /* 恢复原设计的白色文字 */
}

.price-section {
  margin: 1rem 0;
}

.price-section h3 {
  font-size: 1.5rem;
  color: #2c3e50;
  text-align: center;
  margin-bottom: 1rem;
}

.price-section p {
  text-align: center;
  font-size: 1.1rem;
  color: #2c3e50;
  margin: 0.8rem 0;
}

.divider {
  height: 1px;
  background-color: rgba(0, 0, 0, 0.1);
  margin: 2rem 0;
}

.note {
  font-size: 0.9rem;
  font-style: italic;
  text-align: center;
  color: #666;
  margin-top: 1rem;
}

.notice {
  text-align: center;
  margin-top: 1.5rem;
  font-size: 0.9rem;
  color: #666;
}

@media (max-width: 768px) {
  .ticket-container {
    padding: 1rem;
    padding-top: 100px; /* 移动设备上减小顶部内边距 */
  }

  .title {
    font-size: 2.5rem;
  }

  .subtitle {
    font-size: 1.6rem;
    margin-bottom: 1.2rem;
  }

  .showcase-section {
    padding: 1rem;
  }

  .hours-item {
    margin-bottom: 0.6rem;
  }

  .hours-icon {
    font-size: 1.2rem;
    margin-right: 0.8rem;
  }

  .time {
    font-size: 1.1rem;
  }

  .ticket-grid {
    grid-template-columns: 1fr;
    gap: 1.5rem;
    padding: 0 1rem;
  }

  .card-title {
    font-size: 2rem;
  }

  .age-range {
    font-size: 1.3rem;
  }

  .showcase-images {
    flex-direction: column;
    align-items: center;
  }

  .showcase-img {
    width: 100%;
    margin-bottom: 1rem;
  }

  .showcase-text {
    flex-direction: column;
    gap: 1.5rem;
    align-items: center;
    text-align: center;
    padding-right: 0;
  }

  .price-btn {
    margin-top: 1rem;
    align-self: center;
  }
}
</style>